import { Skeleton } from "@mui/material";
import { type FC } from "react";

import * as Styled from "./MarketCalculator.styles";

const COUNTDOWN_HEIGHT = 20;
const QUESTION_HEIGHT = 24;
const AMOUNT_FIELD_HEIGHT = 56;
const TRADE_CARDS_HEIGHT = 148;
const DISCLAIMER_HEIGHT = 14;

export const MarketCalculatorSkeleton: FC = () => {
  return (
    <Styled.Root>
      <Skeleton variant="text" width={180} height={COUNTDOWN_HEIGHT} />

      <Styled.WhiteRoot elevation={0}>
        <Skeleton variant="text" width="100%" height={QUESTION_HEIGHT} />
        <Skeleton variant="text" width="60%" height={QUESTION_HEIGHT} />
        <Skeleton
          variant="rounded"
          width="100%"
          height={AMOUNT_FIELD_HEIGHT}
        />
        <Skeleton variant="rounded" width="100%" height={TRADE_CARDS_HEIGHT} />
        <Skeleton variant="text" width="80%" height={DISCLAIMER_HEIGHT} />
      </Styled.WhiteRoot>
    </Styled.Root>
  );
};
